import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-business",
  "use": "icon-business-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-business\"><defs><style type=\"text/css\">@font-face { font-family: feedback-iconfont; src: url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\n</style></defs><path d=\"M64.234667 1023.744V575.978667h63.957333V128.192h127.936V0.256h639.68v575.722667h63.957333v447.765333H64.234667z m191.893333-831.573333H192.170667v383.808h63.957333V192.170667z m575.701333-127.936H320.106667v511.744h127.914666v127.914666h127.936v-127.936h255.872V64.234667z m63.978667 575.701333H639.936v127.936H384.064v-127.936H128.192v319.829333h767.616V639.936zM384.064 384.064h383.808v63.978667H384.064v-63.978667z m0-191.893333h383.808v63.957333H384.064V192.170667z\" p-id=\"3488\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/business.svg
// module id = Br7G
// module chunks = 36